/**
 * Formatting Utilities for Admin Portal
 */

/**
 * Money formatting — takes rupee amount (string/number) from API, formats for display.
 * API sends "1250.50" -> displays "₹1,250.50"
 */
export function formatINR(amount: number | string | null | undefined): string {
  if (amount === null || amount === undefined || amount === '') return '₹0.00';
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) return '₹0.00';
  return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/**
 * Date/time formatting — takes UTC ISO string from API, converts to IST display.
 * API sends "2026-07-29T08:30:00Z" -> displays "29/07/2026, 2:00:00 pm"
 */
export function formatIST(dateStr: string | null | undefined): string {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '-';
  return date.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
}

/**
 * Date-only formatting in IST timezone.
 */
export function formatISTDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata' });
}

/**
 * Time-only formatting in IST timezone.
 */
export function formatISTTime(dateStr: string | null | undefined): string {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '-';
  return date.toLocaleTimeString('en-IN', { timeZone: 'Asia/Kolkata' });
}
